import * as React from 'react'

const IconBackArrow = (props) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M24 12a1.5 1.5 0 0 1-1.356 1.493l-.144.007H5.121l5.218 5.218a1.5 1.5 0 0 1-2.008 2.224l-.113-.103L.439 13.06a1.5 1.5 0 0 1-.103-2.008l.103-.114L8.218 3.16a1.5 1.5 0 0 1 2.224 2.008l-.103.113L5.12 10.5H22.5A1.5 1.5 0 0 1 24 12z'
      fill='#FFF'
    />
  </svg>
)

export default IconBackArrow
